// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"f3d8aa54","453":"4296a975"}[chunkId] + ".chunk.js";
};